<template>
  <Layout :footer-style="1">
    <div class="rn-blog-details-area">
      <div class="post-page-banner rn-section-gapTop">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content text-center">
                <div class="page-title">
                  <h1 class="theme-gradient">
                    Impressum
                  </h1>
                </div>
                <ul class="rn-meta-list">
                  <li>
                    <Icon name="user" class="size-20"/>
                    <router-link to="#">Octomated GmbH</router-link>
                  </li>
                  <li>
                    <Icon name="calendar" class="size-20"/>
                    18. Oktober 2022
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-details-content pt--60 rn-section-gapBottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content">
                <h4 class="mt-0">Kombinationsimpressum (Anbieterkennzeichnung)</h4>
                <p>Anbieter und somit verantwortlich für das kommerzielle und geschäftsmäßige Onlineangebot ist die
                  Octomated GmbH, vertreten durch die Geschäftsführer Eugen Heinrich und Philipp Wegner.
                  <br>
                  Informationen gemäß Artikel 2 Absatz 1 Dienstleistungs-Informationspflichten-Verordnung (DL-InfoV).
                  <br>
                  Dieses Onlineangebot ist ein Informationsangebot der
                </p>
                <p>
                  Octomated GmbH<br>
                  Pfarrgasse 3<br>
                  D-82266 Inning am Ammersee<br>
                  Deutschland
                </p>

                <h4 class="mt-0">Kontakt</h4>
                <p>
                  Telefon: +49 8143 990370-0<br>
                  E-Mail: info@octomated.com<br>
                  Internet: https://www.octomated.com
                </p>

                <h4 class="mt-0">Sitz</h4>
                <p>D-82266 Inning am Ammersee, Deutschland</p>

                <h4 class="mt-0">Gerichtsstand</h4>
                <p>Amtsgericht München, HRB 271727</p>

                <h4 class="mt-0">Rechtsform</h4>
                <p>Gesellschaft mit beschränkter Haftung (GmbH)</p>

                <h4 class="mt-0">Anwendbares Recht</h4>
                <p>Recht der Bundesrepublik Deutschland (BRD)</p>

                <h4 class="mt-0">Finanzamt</h4>
                <p>Finanzamt Starnberg<br>Umsatzsteuer-Identifikationsnummer: DE350248416</p>

                <h4 class="mt-0">Vertretungsberechtigte Geschäftsführer</h4>
                <p>Eugen Heinrich<br>Philipp Wegner</p>

                <h4 class="mt-0">Gewerbeamt</h4>
                <p>
                  Strandbadstr. 2<br>
                  82319 Starnberg<br>
                  Tel: +49 8151148468<br>
                  Fax: +49 815114811468<br>
                  E-Mail: info@LRA-starnberg.de
                </p>

                <h4 class="mt-0">Zuständige Kammer</h4>
                <p>
                  Industrie- und Handelskammer für München und Oberbayern<br>
                  Körperschaft des öffentlichen Rechts<br>
                  Max-Joseph-Straße 2<br>
                  80333 München<br>
                  Tel: +49 89 5116-0<br>
                  Fax: +49 89 5116-1306<br>
                  E-Mail: info@muenchen.ihk.de
                </p>

                <h4 class="mt-0">Vermögensschadens-Haftpflichtversicherung</h4>
                <p>HISCOX Europe Underwriting Ltd.<br>
                  Arnulfstraße 31, D-80636 München
                </p>

                <h4 class="mt-0">Räumlicher Geltungsbereich</h4>
                <p>Unternehmen der IT- und Telekommunikationsbranche</p>

                <h4 class="mt-0">Informationen zur Online-Streitbeilegung gemäß Artikel 14 Absatz 1 ODR-VO:</h4>
                <p>Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <a
                  href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a> finden. Die
                  OS-Plattform dient als Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten betreffend
                  vertraglicher Verpflichtungen, die aus Online-Kaufverträgen erwachsen.<br><br>

                  Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                  weder verpflichtet noch bereit.</p>


                <h4 class="mt-0">Verantwortlicher für journalistisch redaktionelle Beiträge, gemäß Artikel 18 Absatz 2
                  Medienstaatsvertrag</h4>
                <p>(ehemals in Artikel 55 Absatz 2 Staatsvertrag für Rundfunk und Telemedien (RStV))<br>
                  Eugen Heinrich<br>
                  Octomated GmbH<br>
                  Pfarrgasse 3, D-82266 Inning am Ammersee</p>

                <h4 class="mt-0">Technische Betreuung dieses Onlineangebotes</h4>
                <p>
                  Octomated GmbH<br>
                  Pfarrgasse 3<br>
                  D-82266 Inning am Ammersee<br>
                  Telefon: +49 8143 990370-0<br>
                  E-Mail: info@octomated.com
                </p>

                <h4 class="mt-0">Gegenstand des Unternehmens der Octomated GmbH</h4>
                <p>Entwicklung und der Vertrieb von Software, SaaS und Instandhaltung sowie der Aufbau und die Pflege
                  der Infrastruktur.</p>

                <h4 class="mt-0">Haftungsausschluss</h4>
                <h5 class="mt-0">Haftung für Inhalte</h5>
                <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit
                  und
                  Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß Artikel
                  7 Absatz 1
                  TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach Artikel 8 bis
                  10 TMG sind
                  wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
                  zu
                  überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  Verpflichtungen zur
                  Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
                  unberührt.
                  Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
                  Rechtsverletzung
                  möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
                  entfernen.
                </p>
                <h5 class="mt-0">Haftung für Links</h5>
                <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss
                  haben. Deshalb
                  können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
                  Seiten ist
                  stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
                  zum
                  Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
                  Zeitpunkt der
                  Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
                  ohne konkrete
                  Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden
                  wir
                  derartige Links umgehend entfernen.
                </p>

                <h4 class="mt-0">Markenschutz</h4>
                <p>Jedes hier genannte Firmen- oder Markenzeichen ist Eigentum der jeweiligen Firma. Die Nennung von
                  Marken und Namen geschieht zu rein informativen Zwecken.</p>

                <h4 class="mt-0">Copyright</h4>
                <p>Alle Rechte vorbehalten. Text, Bilder und Grafiken sowie deren Anordnung im Onlineangebot unterliegen
                  dem Schutz des Urheberrechts und anderer Schutzgesetze. Der Inhalt dieses Onlineangebots darf nicht zu
                  kommerziellen Zwecken kopiert, verbreitet, verändert oder Dritten zugänglich gemacht werden.</p>

                <h4 class="mt-0">Hinweis: Allgemeines Gleichbehandlungsgesetz (AGG)</h4>
                <p>Aus Gründen der leichteren Lesbarkeit wird auf eine geschlechterspezifische Differenzierung
                  verzichtet. Entsprechende Begriffe gelten im Sinne der Gleichbehandlung für beide Geschlechter.</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import Breadcrumb from '../components/elements/breadcrumb/Breadcrumb'
import Icon from '../components/icon/Icon'

export default {
  name: 'Imprint',
  components: {Icon, Layout, Breadcrumb},
  metaInfo() {
    return {
      title: this.$t('imprint.meta.title'),
      htmlAttrs: {
        lang: 'de',
      },
      meta: [
        {name: 'description', content: this.$t('imprint.meta.description')},
        {name: 'og:title', content: this.$t('imprint.meta.title')},
        {name: 'og:description', content: this.$t('imprint.meta.description')},
        {name: 'og:locale', content: this.$route.params.locale},
        {name: 'twitter:title', content: this.$t('imprint.meta.title')},
        {name: 'twitter:description', content: this.$t('imprint.meta.description')},
      ],
    }
  },
}
</script>
